/**
 * Starter Pagination — wraps Mantine's `<Pagination>` so the controls
 * pick up the design's brand accent + outlined-default treatment.
 *
 * Mantine's Pagination is functionally complete; this wrapper just
 * threads tokens through to match the rest of the UIKit (border-default
 * outlines, brand active fill via `--button-primary-bg`, focus-ring on tab).
 */
import { forwardRef } from 'react';
import {
  Pagination as MantinePagination,
  type PaginationProps as MantinePaginationProps,
} from '@mantine/core';
import styles from './Pagination.module.css';

export interface PaginationProps extends MantinePaginationProps {}

export const Pagination = forwardRef<HTMLDivElement, PaginationProps>(
  function Pagination({ classNames, ...rest }, ref) {
    const existing = (classNames ?? {}) as {
      root?: string;
      control?: string;
      dots?: string;
    };
    const mergedClassNames = {
      ...existing,
      root: [styles.root, existing.root].filter(Boolean).join(' '),
      control: [styles.control, existing.control].filter(Boolean).join(' '),
      dots: [styles.dots, existing.dots].filter(Boolean).join(' '),
    };
    return (
      <MantinePagination ref={ref} classNames={mergedClassNames} {...rest} />
    );
  },
);
